export default "__VITE_ASSET__Bb_vc13J__"